import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import cn from 'clsx';
import { Button } from '../../button';
import { Modal, ModalHeader } from '../../modal';
import { Typography } from '../../typography';
import {
  creditBlockModalBtn,
  creditBlockModalText,
  creditBlockModalTextLink,
  creditBlockModalTextList,
  creditBlockModalTitle,
} from './credit-block-modal-styles';

type CreditBlockModalProps = {
  isOpen: boolean;
  onClose: () => void;
}

export const CreditBlockModal: React.FC<CreditBlockModalProps> = ({ isOpen, onClose }) => (
  <Modal onClose={onClose} size="m" show={isOpen}>
    <ModalHeader
      className={creditBlockModalTitle}
      title="Кредиты предоставляются банками-партнёрами и&nbsp;МФК"
    />
    <ModalContent>
      <Typography adaptive={false} className={creditBlockModalText} variant="m" size="body_long">
        Кредиты/займы без переплат* и кредиты на большие цели по низкой ставке** предоставляют следующие банки- партнеры и МФК:
      </Typography>

      <ul className={cn(creditBlockModalTextList, creditBlockModalText)}>
        <li>
          <Typography adaptive={false} variant="m" size="body_long">
            — АО «Кредит Европа Банк (Россия)», лицензия ЦБ РФ № 3311 от 03.09.2019 г.
          </Typography>
        </li>
        <li>
          <Typography adaptive={false} variant="m" size="body_long">
            — КБ «Ренессанс Кредит» (ООО), лицензия № 3354 от 26.04.2013 г.
          </Typography>
        </li>
        <li>
          <Typography adaptive={false} variant="m" size="body_long">
            — АО «ОТП Банк», лицензия № 2766 от 27.11.2014 г.
          </Typography>
        </li>
        <li>
          <Typography adaptive={false} variant="m" size="body_long">
            — ООО МФК «ОТП Финанс», регистрация № 651503045006297 от 16.02.2015 г.
          </Typography>
        </li>
        <li>
          <Typography adaptive={false} variant="m" size="body_long">
            — КБ «ЛОКО-Банк» (АО), лицензия № 2707 от 14.09.2015 г.
          </Typography>
        </li>
      </ul>

      <Typography adaptive={false} className={creditBlockModalText} variant="m" size="body_long">
        *Кредит без переплат доступен при покупке проекта «Плитка и тяжёлая сантехника» от 90 000 рублей
        (тяжёлая сантехника — ванны, душевые кабины, ширмы, унитазы, инсталляции), а также проекта «Сантехника»
        — от 50 000 рублей при покупке минимум двух товаров из разных категорий, например: мебель и ванна, мебель
        и унитаз, унитаз и душевая кабина. Кредитне распространяется на отдельные товары из отдела «Сантехника»,
        даже если их стоимость превышает 50 000 рублей. Срок кредита — 6 или 10 месяцев.
      </Typography>
      <Typography adaptive={false} className={creditBlockModalText} variant="m" size="body_long">
        **Кредит на большие цели по низкой ставке доступен при покупке проекта «Плитка и тяжёлая сантехника»
        (через конфигуратор или собранный самостоятельно) на сумму от 90 000 ₽, а также проекта «Сантехника»
        — от 50 000 ₽ при покупке минимум двух товаров из разных категорий, например: мебель и ванна, мебель
        и унитаз, унитаз и душевая кабина. Тяжёлая сантехника — это ванны, душевые кабины, ширмы, унитазы,
        инсталляции. Кредит не распространяется на отдельные товары из отдела «Сантехника», даже если их
        стоимость превышает 50 000 ₽. Срок кредита — 12, 18 или 24 месяца.
      </Typography>
      <Typography adaptive={false} variant="m" size="body_long">
        Подробнее о  кредитных продуктах банков-партнеров и МФК  смотрите на <a className={creditBlockModalTextLink} href="https://lemanapro.ru/service/kredit/" title="Информация по кредитам и кредитам без переплат">https://lemanapro.ru/service/kredit/</a>.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <Button
        adaptive={false}
        className={creditBlockModalBtn}
        href="/service/kredit/"
        target="_blank"
        title="Информация по кредитам и кредитам без переплат"
        wide
      >
        Смотреть полные условия
      </Button>
    </ModalFooter>
  </Modal>
);
